// Regional data structure for Australian states and regions
// This file contains the hierarchical structure: State -> Greater Region -> Sub-Region

export const REGIONAL_DATA = {
  "Queensland": {
    "South East Queensland": [
      "City of Brisbane",
      "Logan City",
      "Redland City",
      "Moreton Bay Region",
      "Gold Coast City",
      "Scenic Rim Regional",
      "Ipswich City",
      "Lockyer Valley Regional"
    ],
    "Darling Downs": [
      "Toowoomba Regional",
      "Southern Downs Regional",
      "Goondiwindi Regional",
      "Western Downs Regional"
    ],
    "Wide Bay-Burnett": [
      "Bundaberg Regional",
      "Fraser Coast Regional",
      "Gympie Regional",
      "North Burnett Regional",
      "South Burnett Regional"
    ],
    "Central Queensland": [
      "Rockhampton Regional",
      "Gladstone Regional",
      "Livingstone Shire",
      "Banana Shire",
      "Central Highlands Regional",
      "Woorabinda Aboriginal Shire"
    ],
    "Mackay, Isaac and Whitsunday": [
      "Mackay Regional",
      "Whitsunday Regional",
      "Isaac Regional"
    ],
    "North Queensland": [
      "Townsville City",
      "Charters Towers Regional",
      "Hinchinbrook Shire",
      "Burdekin Shire",
      "Palm Island Aboriginal Shire"
    ],
    "Far North Queensland": [
      "Cairns Regional",
      "Douglas Shire",
      "Mareeba Shire",
      "Tablelands Regional",
      "Yarrabah Aboriginal Shire",
      "Torres Strait Islands",
      "Cook Shire",
      "Cape York",
      "Mornington Island",
      "Etheridge Shire",
      "Croydon Shire",
      "Carpentaria Shire",
      "Doomadgee Aboriginal Shire",
      "Napranum / Weipa / Western Cape communities",
      "Barcaldine Regional",
      "Barcoo Shire",
      "Boulia Shire",
      "Winton Shire",
      "Longreach Regional",
      "Murweh Shire",
      "Quilpie Shire",
      "Flinders Shire",
      "Diamantina Shire",
      "Burke Shire",
      "McKinlay Shire",
      "Richmond Shire",
      "Cloncurry Shire",
      "Mount Isa City"
    ]
  },
  "New South Wales": {
    "Greater Sydney": [
      "City of Sydney",
      "Inner West Council",
      "Northern Beaches Council",
      "Parramatta City Council",
      "Cumberland Council",
      "Blacktown City Council",
      "Canterbury-Bankstown Council",
      "The Hills Shire",
      "Hornsby Shire",
      "Sutherland Shire",
      "Wollondilly Shire",
      "Camden Council",
      "Campbelltown City Council",
      "Liverpool City Council",
      "Fairfield City Council",
      "Georges River Council",
      "Bayside Council",
      "Strathfield Council",
      "Ryde City Council"
    ],
    "Newcastle and Lake Macquarie": [
      "City of Newcastle",
      "Lake Macquarie City Council",
      "Cessnock City Council",
      "Maitland City Council",
      "Port Stephens Council"
    ],
    "Illawarra": [
      "Wollongong City Council",
      "Shellharbour City Council",
      "Kiama Municipal Council",
      "Shoalhaven City Council"
    ],
    "Hunter Valley": [
      "Singleton Council",
      "Muswellbrook Shire",
      "Upper Hunter Shire"
    ],
    "Richmond Tweed": [
      "Byron Shire",
      "Ballina Shire",
      "Richmond Valley Council",
      "Lismore City Council",
      "Tweed Shire"
    ],
    "Capital Region": [
      "Queanbeyan-Palerang Regional",
      "Goulburn Mulwaree Council",
      "Yass Valley Council",
      "Snowy Monaro Regional"
    ],
    "Mid North Coast": [
      "Port Macquarie-Hastings Council",
      "Kempsey Shire",
      "Nambucca Shire",
      "Bellingen Shire",
      "Coffs Harbour City Council",
      "Clarence Valley Council"
    ],
    "Central West": [
      "Bathurst Regional",
      "Orange City",
      "Blayney Shire",
      "Cabonne Council",
      "Lithgow City Council",
      "Mid-Western Regional",
      "Dubbo Regional",
      "Wellington Council"
    ],
    "New England and North West": [
      "Armidale Regional",
      "Glen Innes Severn",
      "Inverell Shire",
      "Tenterfield Shire",
      "Gunnedah Shire",
      "Narrabri Shire",
      "Tamworth Regional",
      "Walcha Council",
      "Moree Plains Shire",
      "Gwydir Shire"
    ],
    "Riverina": [
      "Wagga Wagga City",
      "Griffith City",
      "Leeton Shire",
      "Narrandera Shire",
      "Murrumbidgee Council",
      "Lockhart Shire",
      "Federation Council",
      "Snowy Valleys Council"
    ],
    "Southern Highlands and Shoalhaven": [
      "Wingecarribee Shire",
      "Kiama Municipal Council",
      "Shoalhaven City Council"
    ],
    "Coffs Harbour-Grafton": [
      "Coffs Harbour City Council",
      "Clarence Valley Council",
      "Bellingen Shire"
    ],
    "Far West and Orana": [
      "Broken Hill City",
      "Central Darling Shire",
      "Cobar Shire",
      "Bourke Shire",
      "Walgett Shire",
      "Bogan Shire",
      "Warren Shire",
      "Brewarrina Shire",
      "Coonamble Shire"
    ],
    "Murray": [
      "Albury City",
      "Greater Hume Shire",
      "Berrigan Shire",
      "Edward River Council",
      "Murrumbidgee Council"
    ]
  },
  "Victoria": {
    "Greater Melbourne": [
      "City of Melbourne",
      "City of Port Phillip",
      "City of Stonnington",
      "City of Yarra",
      "City of Bayside",
      "City of Boroondara",
      "City of Darebin",
      "City of Glen Eira",
      "City of Kingston",
      "City of Maribyrnong",
      "City of Monash",
      "City of Moonee Valley",
      "City of Moreland",
      "City of Whitehorse",
      "City of Manningham",
      "City of Hobsons Bay",
      "City of Brimbank",
      "City of Wyndham",
      "City of Melton",
      "City of Hume",
      "City of Whittlesea",
      "City of Nillumbik",
      "City of Knox",
      "City of Frankston",
      "City of Cardinia",
      "City of Casey",
      "City of Mornington Peninsula"
    ],
    "Barwon South West region": [
      "City of Geelong",
      "Surf Coast Shire",
      "Colac Otway Shire",
      "Moyne Shire",
      "Warrnambool City",
      "Corangamite Shire",
      "Glenelg Shire",
      "Southern Grampians Shire",
      "Queenscliffe Borough"
    ],
    "Gippsland region": [
      "Wellington Shire",
      "Latrobe City",
      "Baw Baw Shire",
      "South Gippsland Shire",
      "Bass Coast Shire",
      "East Gippsland Shire"
    ],
    "Grampians region": [
      "Ballarat City",
      "Golden Plains Shire",
      "Pyrenees Shire",
      "Ararat Rural City",
      "Horsham Rural City",
      "Northern Grampians Shire",
      "West Wimmera Shire",
      "Hindmarsh Shire",
      "Southern Grampians Shire"
    ],
    "Hume region": [
      "Wodonga City",
      "Indigo Shire",
      "Alpine Shire",
      "Towong Shire",
      "Wangaratta Rural City",
      "Benalla Rural City",
      "Mansfield Shire",
      "Strathbogie Shire",
      "Mitchell Shire",
      "Murrindindi Shire"
    ],
    "Loddon Mallee region": [
      "Greater Bendigo City",
      "Loddon Shire",
      "Mount Alexander Shire",
      "Macedon Ranges Shire",
      "Swan Hill Rural City",
      "Gannawarra Shire",
      "Buloke Shire",
      "Mildura Rural City"
    ]
  },
  "Tasmania": {
    "South": [
      "City of Hobart",
      "City of Glenorchy",
      "City of Clarence",
      "Kingborough Council",
      "Brighton Council",
      "Sorell Council",
      "Derwent Valley Council",
      "Huon Valley Council",
      "Tasman Council"
    ],
    "North": [
      "Launceston City",
      "Meander Valley Council",
      "West Tamar Council",
      "Northern Midlands Council",
      "George Town Council",
      "Break O'Day Council",
      "Dorset Council",
      "Flinders Council",
      "Flinders Island"
    ],
    "North-West": [
      "Devonport City",
      "Burnie City",
      "Central Coast Council",
      "Circular Head Council",
      "Waratah-Wynyard Council",
      "Kentish Council",
      "West Coast Council",
      "King Island Council"
    ]
  },
  "South Australia": {
    "Greater Adelaide": [
      "Adelaide City Council",
      "Port Adelaide Enfield Council",
      "Charles Sturt Council",
      "West Torrens Council",
      "Holdfast Bay Council",
      "Marion Council",
      "Mitcham Council",
      "Unley Council",
      "Burnside Council",
      "Campbelltown Council",
      "Norwood Payneham & St Peters Council",
      "Walkerville Council",
      "Prospect Council",
      "Tea Tree Gully Council",
      "Salisbury Council",
      "Playford Council",
      "Onkaparinga Council",
      "Gawler Council"
    ],
    "Murray and Mallee": [
      "Berri Barmera Council",
      "Loxton Waikerie Council",
      "Renmark Paringa Council",
      "Karoonda East Murray Council",
      "Mid Murray Council",
      "Murray Bridge Council"
    ],
    "Eyre and Western": [
      "Ceduna District Council",
      "Streaky Bay Council",
      "Wudinna District Council",
      "Kimba District Council",
      "Elliston District Council",
      "Port Lincoln City Council",
      "Tumby Bay District Council",
      "Lower Eyre Peninsula Council",
      "City of Whyalla",
      "City of Port Augusta",
      "Flinders Ranges Council",
      "City of Port Pirie"
    ],
    "Far North": [
      "Coober Pedy Town Council",
      "Outback Communities Authority",
      "Roxby Downs Council",
      "Maralinga Tjarutja"
    ],
    "Yorke Peninsula and Mid North": [
      "Yorke Peninsula Council",
      "Copper Coast Council",
      "Barunga West Council",
      "Wakefield Regional Council",
      "Clare and Gilbert Valleys Council",
      "Mount Remarkable Council",
      "Northern Areas Council",
      "Port Pirie City Council"
    ],
    "Kangaroo Island": [
      "Kangaroo Island Council"
    ],
    "Limestone Coast": [
      "Mount Gambier City Council",
      "Grant District Council",
      "Kingston District Council",
      "Robe District Council",
      "Naracoorte Lucindale Council",
      "Tatiara District Council"
    ]
  },
  "Western Australia": {
    "Gascoyne": [
      "Carnarvon Shire",
      "Exmouth Shire",
      "Shark Bay / Denham (Shire of Shark Bay)",
      "Upper Gascoyne Shire"
    ],
    "Goldfields–Esperance": [
      "Kalgoorlie-Boulder City",
      "Esperance Shire",
      "Coolgardie Shire",
      "Dundas Shire",
      "Ravensthorpe Shire",
      "Menzies Shire",
      "Leonora Shire",
      "Laverton Shire",
      "Wiluna Shire"
    ],
    "Great Southern": [
      "Albany City",
      "Denmark Shire",
      "Plantagenet Shire",
      "Cranbrook Shire",
      "Gnowangerup Shire",
      "Jerramungup Shire",
      "Katanning Shire"
    ],
    "Kimberley": [
      "Broome Shire",
      "Derby-West Kimberley Shire",
      "Wyndham-East Kimberley Shire",
      "Halls Creek Shire",
      "Cambridge Gulf / Kununurra area (Shire of Wyndham-East Kimberley)"
    ],
    "Mid West": [
      "Geraldton City",
      "Chapman Valley Shire",
      "Northampton Shire",
      "Carnamah Shire",
      "Coorow Shire",
      "Mingenew Shire",
      "Three Springs Shire",
      "Irwin Shire",
      "Morawa Shire",
      "Perenjori Shire"
    ],
    "Peel": [
      "Mandurah City",
      "Murray Shire",
      "Waroona Shire",
      "Serpentine-Jarrahdale Shire"
    ],
    "Pilbara": [
      "Port Hedland Town",
      "Karratha / Roebourne Shire",
      "East Pilbara Shire",
      "Ashburton Shire"
    ],
    "South West": [
      "Bunbury City",
      "Busselton Shire",
      "Dardanup Shire",
      "Capel Shire",
      "Donnybrook-Balingup Shire",
      "Harvey Shire",
      "Augusta-Margaret River Shire"
    ],
    "Wheatbelt": [
      "Northam Shire",
      "Toodyay Shire",
      "York Shire",
      "Beverley Shire",
      "Quairading Shire",
      "Cunderdin Shire",
      "Tammin Shire",
      "Kellerberrin Shire",
      "Merredin Shire",
      "Bruce Rock Shire",
      "Kondinin Shire",
      "Narembeen Shire",
      "Corrigin Shire",
      "Kulin Shire",
      "Lake Grace Shire",
      "Dumbleyung Shire",
      "Wickepin Shire",
      "Wagin Shire",
      "West Arthur Shire",
      "Narrogin Shire",
      "Cuballing Shire",
      "Pingelly Shire",
      "Wandering Shire",
      "Brookton Shire"
    ]
  },
  "Northern Territory": {
    "Greater Darwin": [
      "City of Darwin",
      "City of Palmerston",
      "Litchfield Municipality"
    ],
    "Top End": [
      "Katherine Town Council",
      "Victoria Daly Regional Council",
      "Roper Gulf Regional Council",
      "West Daly Regional Council",
      "Wagait Shire",
      "Belyuen Shire",
      "Tiwi Islands Regional Council"
    ],
    "Big Rivers": [
      "Katherine Town Council (if separate)",
      "Roper Gulf Regional Council (if separate from Top End assignment)",
      "Victoria Daly Regional Council (if separate)"
    ],
    "Barkly": [
      "Barkly Regional Council",
      "Town of Tennant Creek"
    ],
    "East Arnhem": [
      "East Arnhem Regional Council",
      "Nhulunbuy / Gove (within East Arnhem)"
    ],
    "Central Australia": [
      "Alice Springs Town Council",
      "MacDonnell Regional Council",
      "Central Desert Regional Council"
    ]
  },
  "Australian Capital Territory": {
    "Canberra": [
      "Gungahlin",
      "Tuggeranong",
      "Belconnen",
      "Woden Valley",
      "Inner North",
      "Inner South",
      "Molonglo Valley",
      "Canberra Central / Civic"
    ]
  }
};

// Helper function to get all states
export const getStates = () => {
  return Object.keys(REGIONAL_DATA).sort();
};

// Helper function to get greater regions for a state
export const getGreaterRegions = (state) => {
  if (!state || !REGIONAL_DATA[state]) return [];
  return Object.keys(REGIONAL_DATA[state]).sort();
};

// Helper function to get sub-regions for a state and greater region
export const getSubRegions = (state, greaterRegion) => {
  if (!state || !greaterRegion || !REGIONAL_DATA[state] || !REGIONAL_DATA[state][greaterRegion]) {
    return [];
  }
  return REGIONAL_DATA[state][greaterRegion].sort();
};

